import request from '@/sheep/request';


// 查询愿望列表
export const getSearchContent = async (params: any) => {
	return request({
		url: '/wish/wishes/page',
		method: 'GET',
		params
	});
}
